import axiosInstance from '../helpers/axiosInstance'

const BASE = process.env.REACT_APP_PLATFORM_URL

export const INTERACTIVE_TIMEOUT_MS = 20000

const jobsUrl = warehouseId => `${BASE}/api/v1/warehouses/${warehouseId}/print-jobs`

const expectPrintJobsEnvelope = data => {
  if (!data || !Array.isArray(data.print_jobs)) throw new Error('Unexpected print-jobs list response shape')
  return data
}

// Only the fields the WMS reads are validated: `label` is never inspected.
const expectPrintJobEnvelope = data => {
  const job = data && data.print_job
  if (!job || typeof job.barcode !== 'string' || job.barcode === '') throw new Error('Unexpected print-job response shape')
  return job
}

export const fetchPrintJobs = async (warehouseId, params = {}) => {
  const res = await axiosInstance.get(jobsUrl(warehouseId), { params, timeout: INTERACTIVE_TIMEOUT_MS })
  return expectPrintJobsEnvelope(res.data)
}

export const printPrintJobByCode = async (warehouseId, code) => {
  const res = await axiosInstance.post(`${jobsUrl(warehouseId)}/print`, { code }, { timeout: INTERACTIVE_TIMEOUT_MS })
  return expectPrintJobEnvelope(res.data)
}

export const reprintPrintJob = async (warehouseId, id) => {
  const res = await axiosInstance.post(`${jobsUrl(warehouseId)}/${id}/print`, {}, { timeout: INTERACTIVE_TIMEOUT_MS })
  return expectPrintJobEnvelope(res.data)
}
